import { useState } from 'react';
import { useRevertPlanAssignment } from '../hooks/usePlanAssignment';
import { ConfirmDialog } from '@/shared/components/ahkinia/ConfirmDialog/ConfirmDialog';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';
import { Input } from '@/shared/components/ui/input';

interface RevertPlanAssignmentModalProps {
  tenantId: string;
  tenantName: string;
  open: boolean;
  onClose: () => void;
}

export function RevertPlanAssignmentModal({
  tenantId,
  tenantName,
  open,
  onClose,
}: RevertPlanAssignmentModalProps) {
  const { revertAssignment, isReverting } = useRevertPlanAssignment(tenantId);
  const [reason, setReason] = useState('');

  const handleConfirm = () => {
    revertAssignment(reason.trim() || null, {
      onSuccess: () => {
        Notification.success({ title: 'Asignación revertida' });
        setReason('');
        onClose();
      },
    });
  };

  const handleClose = () => {
    if (!isReverting) {
      setReason('');
      onClose();
    }
  };

  return (
    <ConfirmDialog
      open={open}
      onOpenChange={(v) => !v && handleClose()}
      title="Revertir el plan asignado"
      description={`Equivale a cancelar la suscripción de "${tenantName}" y sigue sus mismas reglas.`}
      confirmLabel="Revertir"
      cancelLabel="Cancelar"
      confirmActionType="destructive"
      onConfirm={handleConfirm}
      isPending={isReverting}
      data-testid="revert-assignment-dialog"
    >
      <div className="flex flex-col gap-4">
        {/* Retirarlo de golpe dejaria a un cliente sin servicio por una decision
            administrativa, asi que conserva el acceso hasta el fin del periodo. */}
        <p data-testid="revert-assignment-notice" className="text-primary text-xs">
          La cuenta conserva el acceso hasta el fin del periodo en curso; no se le corta el servicio
          hoy. Si vuelve a necesitar el convenio, hay que asignárselo de nuevo.
        </p>

        <Input
          label="Motivo"
          placeholder="Opcional"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={isReverting}
          data-testid="revert-assignment-reason-input"
        />
      </div>
    </ConfirmDialog>
  );
}
